import axios from "../../../apis/dvdlocator";

export interface FamilyOption {
  value: number;
  label: string;
}

// The product table grid only ever exposes a flattened display string for
// families (product_families_view.families), so the real {id, name} pairs
// needed to safely edit/duplicate a product have to be fetched on demand.
export async function fetchFamiliesByProductId(
  productIds: number[]
): Promise<Map<number, FamilyOption[]>> {
  const res = await axios.post("products/families", { productIds });
  const map = new Map<number, FamilyOption[]>();
  res.data.forEach((entry: any) => {
    map.set(
      entry.productId,
      entry.families.map((f: any) => ({
        value: f.familyId,
        label: f.familyName,
      }))
    );
  });
  return map;
}
